import React, {useCallback} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useSearchMgrInstance} from 'coreHooks';

import messages from 'brandComponents/flyouts/FlyoutFilters/FiltersRefinement/messages';
import {useRefinementsContext} from 'brandComponents/flyouts/FlyoutFilters/FlyoutFilterContext';

import filterContentStyles from './FiltersRefinementContentSorting.module.scss';

const FiltersRefinementContentSorting = () => {
	const {searchConfig, setIsLoading} = useRefinementsContext();
	const searchMgr = useSearchMgrInstance({
		key: searchConfig.searchInstanceKey,
		searchType: searchConfig.searchType,
	});
	const searchModel = searchMgr.getStoredSearchModel();
	const selectedSortingOption = searchModel?.getSelectedSortingOption();
	const sortingOptions = searchModel?.getSortingOptions();
	const intl = useIntl();

	const handleChange = useCallback(
		(sortingOptionId: string) => () => {
			searchMgr.toggleSorting(true, sortingOptionId);
			setIsLoading(true);
			searchMgr.search().finally(() => setIsLoading(false));
		},
		[],
	);

	return sortingOptions.map((sortingOption) => {
		const fallbackLabel = sortingOption.label;
		const attributeId = sortingOption.id;

		const label = messages[attributeId]
			? intl.formatMessage(messages[attributeId]) || fallbackLabel
			: fallbackLabel;

		const isChecked = selectedSortingOption === sortingOption.id;

		return (
			<li key={sortingOption.id} className={filterContentStyles['filters-refinement__item']}>
				<label
					htmlFor={sortingOption.id}
					className={cn(filterContentStyles['filters-refinement__label'], {
						[filterContentStyles.active]: isChecked,
					})}
				>
					<p className={filterContentStyles['filters-refinement__label_text']}>{label.toLowerCase()}</p>
					<input
						id={sortingOption.id}
						className={filterContentStyles['filters-refinement__radio_input']}
						type="radio"
						onChange={handleChange(sortingOption.id)}
						checked={isChecked}
					/>
					<p className={filterContentStyles['filters-refinement__label__wrapper__radio']}>
						<span className={cn(filterContentStyles['filters-refinement__radio'], 'input-radio')}>
							<span className={filterContentStyles['filters-refinement__radio__inner']} />
						</span>
					</p>
				</label>
			</li>
		);
	});
};

export default FiltersRefinementContentSorting;
